import React from "react";
import { connect } from "react-redux";
import Header from "../headerComponent/Header";
import LeftMenu from "../leftSideComponent/LeftSide";
import { Link } from "react-router-dom";
import history from "../../auth/history";
import moment from "moment";

class PaymentSuccess extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			phoneNo: this.props.phone,
		}
	}


	componentDidMount() { }
	componentWillUnmount() {
	}



	render() {

		return (
			<div>
				<div class="main">
					<LeftMenu />

					<div class="right-side">
						<div class="container-fluid">
							<Header />
							<div class="row">
								<div class="col-12 col-lg-8">
									<div class="card">
										<div class="dashhead">
											<h3>Load Money Details</h3>
											<div class="backbtn">
												<Link to='/manage-payment'>
												<button type="button" class="back">Back</button>
												</Link>
											</div>
										</div>

										<div class="loaddtl">
											<h4>Thank you, Load money Details has been submited successfully!</h4>
											<div class="table-responsive">
												<table class="table table-bordered">
													<thead>
														<tr>
															<td width="150">Load Amount:</td>
															<td>₹ {(this.props.claimResp.amount != '' &&
																this.props.claimResp.amount != null &&
																this.props.claimResp.amount != undefined) ?
																parseFloat(this.props.claimResp.amount).toFixed(2) : 'NA'
															}</td>
														</tr>
														<tr>
															<td>Bank Name:</td>
															<td>{(this.props.claimResp.bank != '' &&
																this.props.claimResp.bank != null &&
																this.props.claimResp.bank != undefined) ?
																this.props.claimResp.bank : 'NA'
															}</td>
														</tr>
														<tr>
															<td>Transaction ID:</td>
															<td>  {(this.props.claimResp.utr != '' &&
																this.props.claimResp.utr != null &&
																this.props.claimResp.utr != undefined) ?
																this.props.claimResp.utr : 'NA'
															}</td>
														</tr>
														<tr>
															<td>Date:</td>
															<td>{(this.props.claimResp.txnDate != '' &&
																this.props.claimResp.txnDate != null &&
																this.props.claimResp.txnDate != undefined) ?
																moment(this.props.claimResp.txnDate).format('DD-MM-YYYY') : 'NA'
															}</td>
														</tr>
														<tr>
															<td>Transaction Mode:</td>
															<td>{(this.props.claimResp.txnMode != '' &&
																this.props.claimResp.txnMode != null &&
																this.props.claimResp.txnMode != undefined) ?
																this.props.claimResp.txnMode : 'NA'
															}</td>
														</tr>
														<tr>
															<td>Request ID:</td>
															<td>{(this.props.claimResp.refId != '' &&
																this.props.claimResp.refId != null &&
																this.props.claimResp.refId != undefined) ?
																this.props.claimResp.refId : 'NA'
															}</td>
														</tr>
													</thead>
												</table>
											</div>
										</div>

										{/* <div class="txn-btn">
								<button type="button" class="print" data-bs-toggle="modal" data-bs-target="#print">Print</button>
								<button type="button" class="share">Share</button>
								<button type="button" class="help">Support</button>
							</div> */}
									</div>
								</div>

								<div class="col-12 col-lg-4">
									<div class="card">
										<div class="dashhead">
											<h3>Bank-to-Bank Transfer Details</h3>
										</div>

										<div class="btbtnsfr">
											<p>Now you can load money in your corporate virtual account through NEFT/RTGS as per process shown below.</p>

											<p>Account Details for adding Payee as mentioned as below:</p>

											<div class="table-responsive">
												<table class="table table-bordered">
													<thead>
														<tr>
															<td>Payee Name:</td>
															<td>FinXpay Solutions Pvt. Ltd.</td>
														</tr>
														<tr>
															<td>Account Number:</td>
															<td>FINXPAY4248795778</td>
														</tr>
														<tr>
															<td>Bank Name:</td>
															<td>Yes Bank Ltd.</td>
														</tr>
														<tr>
															<td>Bank IFSC Code:</td>
															<td>YESB0CMSNOC</td>
														</tr>
														<tr>
															<td>Account Type:</td>
															<td>Current Account</td>
														</tr>
													</thead>
												</table>
											</div>
										</div>
									</div>
								</div>

							</div>
						</div>
					</div></div>
				<div class="footer-txt">Copyright &copy; 2021 All rights reserved.
					<br />Powered by FinXpay Solutions Pvt. Ltd.</div>
			</div>
		);
	}
}

const mapStateToProps = (
	{ errorMessageReduce: { errorMessage },
		miscReduce: { phone, claimResp } }
) => ({
	errorMessage, phone, claimResp
});

export default connect(mapStateToProps, null)(PaymentSuccess);
